/*
 * hotel-size-guide.js
 * Opens (and scrolls to) the Size Guide accordion further down the product page.
 *
 * Two triggers, both delegated from document:
 *   1. [data-hotel-size-guide] — the SIZE GUIDE button above the size pills
 *      (snippets/hotel-product-variant-picker.liquid).
 *   2. Any link whose href hash is "#size-guide" — for merchant-authored
 *      mentions inside rich-text content. Shopify's rich-text sanitiser strips
 *      data-* attributes, so an href is the ONLY hook a merchant can type in the
 *      theme editor. Works in both `richtext` and `inline_richtext` settings
 *      (both permit <a>), e.g. the icon-with-text USP rows and multicolumn text.
 *      Authoring: insert a link with the URL "#size-guide".
 *
 * The accordion is a Dawn collapsible_tab (<details> with the heading in
 * summary .accordion__title), so we match it by its heading text — no shared id
 * needed between the trigger and the block.
 *
 * Upgrade-safe: a delegated document click listener; never patches Dawn files.
 */
(function () {
  function findSizeGuide() {
    var match = null;
    document.querySelectorAll('.product__accordion details').forEach(function (d) {
      if (match) return;
      var title = d.querySelector('summary .accordion__title, summary h2, summary');
      if (title && title.textContent.trim().toLowerCase().indexOf('size guide') !== -1) {
        match = d;
      }
    });
    return match;
  }

  function isTrigger(target) {
    if (target.closest('[data-hotel-size-guide]')) return true;
    var link = target.closest('a[href]');
    if (!link) return false;
    // Matches a bare "#size-guide" and a full URL ending in that hash.
    return (link.getAttribute('href') || '').split('#')[1] === 'size-guide';
  }

  document.addEventListener('click', function (event) {
    if (!isTrigger(event.target)) return;
    event.preventDefault();
    var details = findSizeGuide();
    if (!details) return;
    details.open = true;
    details.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
